"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var activityListApi = _interopRequireWildcard(require("@/api/activityListApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      initDetail: {},
      tagType: 1,
      headOption: []
    };
  },
  computed: {
    // 订单类型标签
    orderTypeLabel: function orderTypeLabel() {
      if (!this.initDetail.insertOrder) return '-';
      switch (this.initDetail.orderType) {
        case 1:
          return '普通订单';
        default:
          return '未知类型';
      }
    },
    // 商品类型标签
    productTypeLabel: function productTypeLabel() {
      if (!this.initDetail.insertOrder) return '-';
      switch (this.initDetail.allProducts) {
        case 0:
          return '所有商品';
        case 1:
          return '指定SKU';
        case 2:
          return '指定分类';
        default:
          return '未知配置';
      }
    }
  },
  mounted: function mounted() {
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: _defineProperty(_defineProperty({
    // 获取商品详情文本
    getProductDetailText: function getProductDetailText() {
      if (this.initDetail.allProducts === 1) {
        // 处理SKU数据
        if (this.initDetail.skuList && Array.isArray(this.initDetail.skuList) && this.initDetail.skuList.length > 0) {
          // 使用后端返回的完整商品信息
          var skuInfo = this.initDetail.skuList.map(function (item) {
            return "".concat(item.skuCode || 'SKU-' + item.id, "(").concat(item.storeName || '', ")");
          }).join(', ');
          return "\u5DF2\u9009\u62E9 ".concat(this.initDetail.skuList.length, " \u4E2A\u5546\u54C1: ").concat(skuInfo);
        } else if (this.initDetail.specifiedProducts) {
          // 后端没有返回完整商品信息，使用ID列表
          try {
            // 尝试解析JSON格式的SKU IDs
            var skuIds = JSON.parse(this.initDetail.specifiedProducts);
            if (Array.isArray(skuIds)) {
              return "\u5DF2\u9009\u62E9 ".concat(skuIds.length, " \u4E2ASKU (ID: ").concat(skuIds.join(', '), ")");
            } else {
              return "SKU ID: ".concat(this.initDetail.specifiedProducts);
            }
          } catch (e) {
            // 尝试以逗号分隔解析
            var _skuIds = this.initDetail.specifiedProducts.split(',').filter(function (id) {
              return id.trim();
            });
            if (_skuIds.length > 0) {
              return "\u5DF2\u9009\u62E9 ".concat(_skuIds.length, " \u4E2ASKU (ID: ").concat(_skuIds.join(', '), ")");
            } else {
              return "SKU ID: ".concat(this.initDetail.specifiedProducts);
            }
          }
        }
      } else if (this.initDetail.allProducts === 2 && this.initDetail.specifiedCategories) {
        // 处理分类数据
        if (Array.isArray(this.initDetail.specifiedCategories)) {
          // 已经是数组格式
          return "\u5DF2\u9009\u62E9 ".concat(this.initDetail.specifiedCategories.length, " \u4E2A\u5206\u7C7B (ID: ").concat(this.initDetail.specifiedCategories.join(', '), ")");
        } else {
          try {
            // 尝试解析JSON格式
            var categoriesData = JSON.parse(this.initDetail.specifiedCategories);

            // 处理嵌套数组格式
            if (Array.isArray(categoriesData) && categoriesData.length > 0 && Array.isArray(categoriesData[0])) {
              // 提取分类路径信息
              var pathsInfo = categoriesData.map(function (path) {
                if (Array.isArray(path)) {
                  return path.join(' > ');
                }
                return String(path);
              });
              return "\u5DF2\u9009\u62E9 ".concat(categoriesData.length, " \u4E2A\u5206\u7C7B\u8DEF\u5F84: ").concat(pathsInfo.join('; '));
            } else if (Array.isArray(categoriesData)) {
              // 普通数组
              return "\u5DF2\u9009\u62E9 ".concat(categoriesData.length, " \u4E2A\u5206\u7C7B (ID: ").concat(categoriesData.join(', '), ")");
            } else {
              return "\u5206\u7C7B\u6570\u636E: ".concat(this.initDetail.specifiedCategories);
            }
          } catch (e) {
            // 尝试以逗号分隔解析
            var categories = String(this.initDetail.specifiedCategories).split(',').filter(function (id) {
              return id.trim();
            });
            if (categories.length > 0) {
              return "\u5DF2\u9009\u62E9 ".concat(categories.length, " \u4E2A\u5206\u7C7B (ID: ").concat(categories.join(', '), ")");
            } else {
              return "\u5206\u7C7BID: ".concat(this.initDetail.specifiedCategories);
            }
          }
        }
      }
      return '无详情';
    },
    // 打开
    initOpen: function initOpen(row) {
      var _this = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.tagType = type;
      this.initDetail = row || {};
      this.visibleDrawer = true;
      this.headOption = [];
      activityListApi.userSubmitSkinFormHead({
        id: row.id
      }).then(function (res) {
        _this.headOption = res || [];
        _this.handlerGetListData(_this.listPram);
      });
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      activityListApi.userSubmitSkinForm(_objectSpread(_objectSpread({}, pram), {}, {
        id: this.initDetail.id
      })).then(function (data) {
        _this2.listData = data;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }, "closeDrawer", function closeDrawer() {
    this.visibleDrawer = false;
    this.$emit('doRefresh');
  }), "exportList", function exportList() {
    activityListApi.exportSubmitSkinForm(_objectSpread(_objectSpread({}, this.listPram), {}, {
      id: this.initDetail.id
    })).then(function (res) {
      window.open(res.fileName);
    });
  })
};